import { render, staticRenderFns } from "./RemoveDevice.vue?vue&type=template&id=79bcf052&"
import script from "./RemoveDevice.vue?vue&type=script&lang=js&"
export * from "./RemoveDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports